<template>
  <div class="buttons">
    <b-button type="is-primary" @click="saveDocument">
      <span class="icon is-small">
        <i class="mdi mdi-content-save-outline"></i> </span
      ><span>Сохранить</span>
    </b-button>

    <b-button
      type="is-warning"
      @click="generateDocument"
      v-if="objectsCreationAllowed"
    >
      <span class="icon is-small">
        <i class="mdi mdi-application-export"></i> </span
      ><span>Сформировать документ</span>
    </b-button>

    <b-dropdown aria-role="list" v-if="printAllowed && $route.params.id">
      <button class="button is-primary" slot="trigger">
        <span><i class="mdi mdi-printer"></i> Печать</span>
        <b-icon icon="menu-down"></b-icon>
      </button>
      <b-dropdown-item aria-role="listitem" @click="previewDocument()"
        ><i class="mdi mdi-file-eye-outline"></i> Предпросмотр</b-dropdown-item
      >
      <b-dropdown-item aria-role="listitem" @click="printDocument()"
        ><i class="mdi mdi-printer"></i> Печатать документ</b-dropdown-item
      >
    </b-dropdown>

    <b-dropdown aria-role="list" v-if="exportAllowed && $route.params.id">
      <button class="button is-primary" slot="trigger">
        <span><i class="mdi mdi-file-export-outline"></i> Экспорт</span>
        <b-icon icon="menu-down"></b-icon>
      </button>
      <b-dropdown-item aria-role="listitem" @click="exportDocument('PDF')"
        ><i class="mdi mdi-file-pdf-outline"></i> Экспорт в
        .pdf</b-dropdown-item
      >
      <b-dropdown-item aria-role="listitem" @click="exportDocument('Word2007')"
        ><i class="mdi mdi-file-word-outline"></i> Экспорт в
        .docx</b-dropdown-item
      >
    </b-dropdown>

    <slot name="navigation"></slot>
  </div>
</template>

<script>
export default {
  name: 'SectionActions',

  props: {
    objectsCreationAllowed: {
      type: Boolean,
      default: true,
    },

    exportAllowed: {
      type: Boolean,
      default: false,
    },

    printAllowed: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    saveDocument() {
      this.$emit('saveDocument')
    },

    generateDocument() {
      this.$emit('generateDocument')
    },

    printDocument() {
      this.$emit('printDocument')
    },

    previewDocument() {
      this.$emit('previewDocument')
    },

    exportDocument(type) {
      this.$emit('exportDocument', type)
    },
  },
}
</script>
